import { toPng } from 'html-to-image';

// Renders a dashboard card node to PNG and triggers the download. Elements
// marked with data-export-exclude (the export button itself) are pruned from
// the capture; the background is forced white regardless of page bg.
export async function exportCardPng(node, cardKey) {
  if (!node) return;
  const dataUrl = await toPng(node, {
    backgroundColor: '#FFFFFF',
    pixelRatio: 2,
    filter: (child) => !(child.dataset && child.dataset.exportExclude !== undefined),
  });
  const link = document.createElement('a');
  link.download = `masraf-dashboard-${cardKey}-${new Date().toISOString().slice(0, 10)}.png`;
  link.href = dataUrl;
  link.click();
}
